'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data, barSpaceWidth) {
  var rankingsPerformData = _.map(data, 'data');
  var dataWithoutGaps = _.filter(data, ['isGap', false]);
  var yMin = d3.min(dataWithoutGaps, function (d) {
    var minCircle = _.minBy(d.circles, 'value');
    return _.min([d.m1, d.m2, minCircle ? minCircle.value : 0, 0]);
  }) || 0;
  var yMax = d3.max(dataWithoutGaps, function (d) {
    var maxCircle = _.maxBy(d.circles, 'value');
    return _.max([d.m1, d.m2, maxCircle ? maxCircle.value : 0, 0]);
  }) || 0;
  var dataBarsWidth = barSpaceWidth * data.length;
  var xMax = dataBarsWidth > params.width ? dataBarsWidth : params.width;
  var x = d3.scale.ordinal().domain(_.map(data, 'label')).range(rankingsPerformData.map(function (element, index) {
    return 5 + barSpaceWidth * index;
  }).concat([0, xMax]));
  x.rangeBand = function () {
    return 42;
  };
  x.rangeExtent = function () {
    return [0, dataBarsWidth];
  };
  x.linesRange = function () {
    return [-20, xMax];
  };
  var y = d3.scale.linear().domain([yMin, yMax]).rangeRound([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;